export const getErrorMessage = (r) =>
  r instanceof Error ? r.message : String(r);
